import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

@Component({
    selector: 'cd-timer',
    template: `{{ _displayTime }}`,
    standalone: false
})
export class CdTimerComponent implements OnDestroy {
  @Input() countdown: boolean | string = true;
  @Input() startTime: number | string = 0;
  @Input() format: string = 'intelli';
  @Output() onComplete = new EventEmitter<void>();

  public _displayTime = '00:00';
  private _remainingSeconds = 0;
  private _intervalRef: ReturnType<typeof setInterval> | null = null;

  public start(): void {
    this.stop();

    const _inputValue = Number(this.startTime);
    this._remainingSeconds = Number.isFinite(_inputValue) && _inputValue > 0 ? _inputValue : 0;
    this._displayTime = this._formatTime(this._remainingSeconds);

    if (!this._isCountdownEnabled() || this._remainingSeconds <= 0) {
      // Nothing to count down, keep a stable rendered value.
      return;
    }

    this._intervalRef = setInterval(() => {
      // Stop at zero to avoid negative timer values.
      if (this._remainingSeconds <= 1) {
        this._remainingSeconds = 0;
        this._displayTime = this._formatTime(this._remainingSeconds);
        this.stop();
        this.onComplete.emit();
        return;
      }

      this._remainingSeconds -= 1;
      this._displayTime = this._formatTime(this._remainingSeconds);
    }, 1000);
  }

  public stop(): void {
    if (this._intervalRef) {
      clearInterval(this._intervalRef);
      this._intervalRef = null;
    }
  }

  public ngOnDestroy(): void {
    this.stop();
  }

  private _isCountdownEnabled(): boolean {
    return this.countdown === true || `${this.countdown}`.toLowerCase() === 'true';
  }

  private _formatTime(_totalSeconds: number): string {
    const _hours = Math.floor(_totalSeconds / 3600);
    const _minutes = Math.floor((_totalSeconds % 3600) / 60);
    const _seconds = _totalSeconds % 60;

    if (this.format === 'intelli' && _hours > 0) {
      return `${this._pad(_hours)}:${this._pad(_minutes)}:${this._pad(_seconds)}`;
    }

    const _totalMinutes = Math.floor(_totalSeconds / 60);
    return `${this._pad(_totalMinutes)}:${this._pad(_seconds)}`;
  }

  private _pad(_value: number): string {
    return _value.toString().padStart(2, '0');
  }
}
